export default {
  companyOpportunities: null,
  aggregatorOpportunityId: null,
  isILOFormSubmitted: false
}
